import { PingResponseContent } from '@equaliq/api-model';
import { createApiRequest } from "src/api/common";

export const pingApi = async (): Promise<PingResponseContent> => {
  const request = createApiRequest<PingResponseContent>(
    "post",
    "/ping"
  )
  return request({});
};